import { useEffect } from 'react'
import styled from '@emotion/styled'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import Box from '@mui/material/Box'

const ScrollButton = styled(Box)`
  ${({ theme }) => `
    position: fixed;
    bottom: 100px;
    right: 20px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);
    background-color: ${theme.palette.grey.third};
    border: 1px solid ${theme.palette.grey.secondary};
    cursor: pointer;
    color: ${theme.palette.text.primary};
    z-index: 98;

    &:active {
      background-color: ${theme.palette.primary.bgPlus1};
      border: 1px solid #ffffff;
    }

    > .muiIcon {
      position: absolute;
      top: 50%; 
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`

const ScrollToTopButton = ({ showButton, scrollableRef, isAutoScroll }) => {
  const onScrollToTopClick = () => {
    setTimeout(
      () =>
        scrollableRef.current &&
        scrollableRef.current?.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
      0
    )
  }

  useEffect(() => {
    if (isAutoScroll) {
      setTimeout(
        () =>
          scrollableRef.current &&
          scrollableRef.current?.scrollTo({
            top: 0,
            behavior: 'smooth',
          }),
        0
      )
    }
  }, [isAutoScroll])

  return (
    <ScrollButton
      style={{ display: showButton ? 'inline' : 'none' }}
      onClick={onScrollToTopClick}
    >
      <ExpandLessIcon fontSize="large" className="muiIcon" />
    </ScrollButton>
  )
}

export default ScrollToTopButton
